module.exports = __webpack_public_path__ + "static/media/plus_circle.275531f7.svg";